import { FC } from 'react'
import { Typography, Grid } from '@mui/material'


const TnCHeader: FC<{}> = () => {
 
  return (
    <>
      <Grid container  alignItems="stretch">
        <Grid item md={6}>
          <Typography variant="h3" component="h3">
            Invoice & Challan Settings
          </Typography>
         
        </Grid>
       
      </Grid>

    </>
  )
}

export default TnCHeader
